module.exports = __webpack_public_path__ + "static/media/serviceFb.9f5aff51.png";